import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'react-flexbox-grid'
import get from 'lodash/get'

import { Form, Text, Select, Checkbox } from 'components/forms'
import ClientSelector from 'components/forms/ClientSelector'
import Button from 'components/Button'
import { notEmpty } from 'helpers/validators'
import createCashRegisterMutation from '../../gql/createCashRegister'
import { StatusIndicatorContext, useMutation } from 'components/graphql'
import { listCashRegisters } from 'gql/query'

const NewCashRegister = ({ history }) => {
	const [t] = useTranslation()
	const { setAlert } = useContext(StatusIndicatorContext)
	const [createCashRegister] = useMutation(createCashRegisterMutation)
	const handleCreate = variables => {
		return createCashRegister({
			variables,
			refetchQueries: ['clientTree', { query: listCashRegisters }],
			update: (cache, { data }) => {
				const id = get(data, 'createCashRegister.id')
				if(id !== 'neue') {
					history.push({
						pathname: `/optionen/kasse/${id}`
					})
				}
			}
		}).catch(err=>{
			let errKey
			const checkError = err.graphQLErrors.find((item, key) => {
				if(item.path.includes('createCashRegister')) {
					errKey = key
				}
				return item.path.includes('createCashRegister')
			})
			const hardwareIdError = !!checkError && (get(err, `graphQLErrors[${errKey}].extensions.invalidArgs`, false)).includes('hardwareId')

			if(hardwareIdError) {
				setAlert({ show: true, text: t('server_errors.unregistered_android_device') })
			}
			// Rethrow error to be catched in withServerErrors HOC to set error to the form field
			throw err
		})
	}

	//
	return(
		<Form initialValues={{ deviceType: 'SMART_CHECKOUT' }} onSubmit={handleCreate} render={({ formState, formApi }) => (
			<Row>
				<Col xs>
					<Select
						field='deviceType'
						label={t('options_section.fields.cash_register_type')}
						options={[{
							label: 'SelfCheckout',
							value: 'SELF_CHECKOUT'
						}, {
							label: 'SmartCheckout',
							value: 'SMART_CHECKOUT'
						}, {
							label: 'Mobile Waiter',
							value: 'MOBILE_WAITER'
						}, {
							label: 'SmartLabel',
							value: 'SMART_LABEL'
						}, {
							label: 'KDS',
							value: 'KDS'
						}
						/*, {/*, {
							label: 'Kassensystem',
							value: 'OLD_CASHREGISTER'
						}*/]}
					/>
					<Text label={t('options_section.fields.title')} field='fields.name' {...notEmpty()} validateOnChange />
					<Text label={t('options_section.fields.android_serial_number')} field='hardwareId' />
					<Select
						field='settingsCopyId'
						valueField='id'
						labelField='name'
						isClearable
						removeOnClear
						remoteOptions={{ query: listCashRegisters }}
						label={t('options_section.fields.settings_from_cash_register')}
					/>
					<Checkbox field='deactivateAllContent' label='Deaktivieren von Inhalten auf dem Gerät'/>
					{/*formState.values.deviceType === 'OLD_CASHREGISTER' &&
						<Fragment>
							<Text label='Confirmation code' field='consoleCode' {...notEmpty()} validateOnChange />
							<div>from console.hssoft.com</div>
						</Fragment>
					*/}
					<Button type='submit' text={t('common.buttons.save')} status='primary' size='small'/>
				</Col>
				<Col xs>
					<ClientSelector lastNode='SHOP' field='fields.shopId' {...notEmpty()} />
				</Col>
			</Row>
		)}/>
	)
}

export default NewCashRegister
